// RecursiveMenu.jsx
import React, { useState } from 'react';
import './RecursiveMenu.css';
import { RightOutlined, CloseOutlined } from '@ant-design/icons';
import CONSTANTS from 'constants';

const RecursiveDepth = ({ items = [], depth = 0, onClose }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const isMobile = window.innerWidth <= 1200;
  const menuWidth = isMobile ? 160 : 220;

  return (
    <ul
      className="recursive_menu"
      style={{
        position: 'fixed',
        top: 0,
        left: `${depth * menuWidth}px`,
        listStyle: 'none',
        margin: 0,
        padding: 0,
        height: '100vh',
        backgroundColor: '#fff',
        borderLeft: '1px solid #ddd',
        zIndex: 10000 + depth,
      }}
    >
      {items.map((currentItem, index) => {
        const hasChildren =
          Array.isArray(currentItem.children) &&
          currentItem.children.length > 0;

        return (
          <li
            key={index}
            className="menu_item"
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
            onClick={(e) => {
              e.stopPropagation();
              if (typeof currentItem.onClick === 'function') {
                currentItem.onClick();
              }
              if (typeof onClose === 'function') {
                onClose();
              }
            }}
            style={{ position: 'relative' }}
          >
            <span>{currentItem.title}</span>
            {hasChildren && <RightOutlined className="arrow_icon" />}

            {hoveredIndex === index && hasChildren && (
              <RecursiveDepth
                items={currentItem.children}
                depth={depth + 1}
                onClose={onClose}
              />
            )}
          </li>
        );
      })}
    </ul>
  );
};

const RecursiveMenu = ({ menus = [], isOpen, onClose }) => {
  const [activeMenu, setActiveMenu] = useState(null);

  return (
    isOpen && (
      <div className="mega_menu_overlay" onClick={onClose}>
        <div
          className="mega_menu_wrapper_auto"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="mega_menu_header">
            <span>전체 카테고리</span>
            <CloseOutlined className="close_icon" onClick={onClose} />
          </div>

          <div className="menu_depth_wrapper" style={{ position: 'relative' }}>
            <ul className="mega_menu_primary">
              {menus.map((menu, index) => {
                const hasChildren =
                  Array.isArray(menu.children) && menu.children.length > 0;
                return (
                  <li
                    key={index}
                    className={`primary_item ${
                      menu.title === CONSTANTS.BUSINESS_CATEGORY_NAME
                        ? 'business'
                        : ''
                    } ${activeMenu === index ? 'active' : ''}`}
                    onMouseEnter={() => setActiveMenu(index)}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (typeof menu.onClick === 'function') {
                        menu.onClick();
                      }
                      if (typeof onClose === 'function') {
                        onClose();
                      }
                    }}
                  >
                    <span>{menu.title}</span>
                    {hasChildren && <RightOutlined className="arrow_icon" />}
                  </li>
                );
              })}
            </ul>

            {activeMenu !== null &&
              Array.isArray(menus[activeMenu]?.children) &&
              menus[activeMenu].children.length > 0 && (
                <RecursiveDepth
                  items={menus[activeMenu].children}
                  depth={1}
                  onClose={onClose}
                />
              )}
          </div>
        </div>
      </div>
    )
  );
};

export default RecursiveMenu;
